import React from 'react';

export default function RadioBoxField({
    currentItem,
    onChangeHandler,
    fieldData,
    currentStateValue,
    defaultStateValue,
    controlStateData,
    size = 'small',
    beforeIcon = null,
    afterIcon = null,
    reverse = false,
}) {
    const isEmptyState = typeof currentStateValue === 'number' ? !Number.isFinite(currentStateValue) : !currentStateValue || currentStateValue?.trim() === '';
    const isFormSubmit = controlStateData && controlStateData.isSubmit;
    const isRequiredError = fieldData.isRequired && isEmptyState;

    return (
        <>
            <input
                className={`form__input--radio ${size === 'small' ? 'form__radio--small' : ''} ${reverse ? 'form__input--radio-reverse' : ''} d-flex align-items-center`}
                type="radio"
                id={currentItem.id}
                name={fieldData.name}
                value={currentItem.value}
                checked={currentStateValue !== null ? currentStateValue === currentItem.value : defaultStateValue === currentItem.value}
                onChange={onChangeHandler}
            />
            <label className={`form__label--radio my-0 ${reverse ? 'd-flex flex-row-reverse' : ''}`} htmlFor={currentItem.id}>
                <span className="form__label-title-container">
                    {beforeIcon}
                    <span
                        className={`form__labelTitle ${isRequiredError && isFormSubmit ? 'form__labelTitle--error' : ''}`}
                    >
                        {currentItem.title || currentItem.commentText}
                    </span>
                    {afterIcon}
                </span>
            </label>
        </>
    );
}
